import { CONTENT_ID } from '../consts';
import { generateMultipleSetContent, generateSetContent } from './utils';

export const setCuisineFilters = generateSetContent(CONTENT_ID.CUISINE_FILTERS);
export const setDatePicker = generateSetContent(CONTENT_ID.DATE_PICKER);
export const setDietaryFilters = generateSetContent(CONTENT_ID.DIETARY_FILTERS);
export const setFilterBar = generateMultipleSetContent(CONTENT_ID.FILTER_BAR, CONTENT_ID.FILTER_BAR_INLINE);
export const setMenuBar = generateSetContent(CONTENT_ID.MENU_BAR);
export const setMoreFilters = generateSetContent(CONTENT_ID.MORE_FILTERS);
export const setNavigation = generateSetContent(CONTENT_ID.NAVIGATION);
export const setPromoSpacer = generateSetContent(CONTENT_ID.PROMO_SPACER);
export const setProteinFilters = generateSetContent(CONTENT_ID.PROTEIN_FILTERS);
export const setSearch = generateSetContent(CONTENT_ID.SEARCH);
export const setSubCuisineFilters = generateSetContent(CONTENT_ID.SUB_CUISINE_FILTERS);
